import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

const AUTH_ERROR_MESSAGES: Record<string, MessageDescriptor> = defineMessages({
  InvalidTenant: { id: 'Invalid tenant' },
  EmailNotInvited: { id: 'The email has not received an invitation to this organization' },
  InvalidLoginAttempt: { id: 'Invalid login attempt' },
  InvalidRequest: { id: 'Invalid request' },
  InvalidOrExpiredResetLink: { id: 'Invalid or expired reset link' },
  InvalidOrExpiredLink: { id: 'Invalid or expired link' },
  ExternalProviderError: { id: 'Error from external provider' },
  AccountNotAllowed: { id: 'This account is not allowed to access the platform.' },
  UnexpectedSignInError: {
    id: 'An unexpected error occurred while attempting to sign you in with your new account.'
  }
});

const GENERIC_SUCCESS_MESSAGE: MessageDescriptor = { id: 'Success' };
const GENERIC_ERROR_MESSAGE: MessageDescriptor = { id: 'An error occurred (code: {code})' };

export function useAuthResultMessageFormatter(): (
  success: boolean,
  code: string | null
) => string | null {
  const { formatMessage } = useIntl();
  return useCallback(
    (success: boolean, code: string | null): string | null => {
      if (success) return formatMessage(GENERIC_SUCCESS_MESSAGE);
      if (!code) return null;
      const descriptor = AUTH_ERROR_MESSAGES[code];
      if (descriptor) return formatMessage(descriptor);
      return formatMessage(GENERIC_ERROR_MESSAGE, { code });
    },
    [formatMessage]
  );
}
